module.exports = "/hwa/_next/static/images/cardboard-74683f5c06f21aebce22405c98ce1501.png";